module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-BITBUCKET.e737cdf2.png";